import { HttpRequest, HttpMethod } from "./http";

/**
 * Per-user pinned tabs of the BO page taskbar, kept server-side so the pins
 * follow the staff member across browsers / devices.
 * Spec: docs/specs/2026-10-05-bo-taskbar-server-pins-design.md §3.
 *
 * GET  /api/v1/profile/taskbar
 *   -> { Data: [ { storage: "server"|"local", pinned: [{key,label,seq}]|null, updated_at: string|null } ] }
 *      (envelope `Data` is an array; the current item is element [0])
 * PUT  /api/v1/profile/taskbar
 *   body: { pinned: [{key,label,seq}, ...] }   (replaces the whole set, <= 5)
 *
 * storage:"local" = the table is not there yet; the taskbar keeps working from
 * localStorage only, exactly as before this feature.
 */
class TaskbarProvider extends HttpRequest {
    Get() {
        return this.request(HttpMethod.Get, `/api/v1/profile/taskbar`);
    }

    Update(payload) {
        return this.request(HttpMethod.Put, `/api/v1/profile/taskbar`, payload);
    }
}

export default TaskbarProvider;
